import axios from 'axios/index'

import config from '../../../config'
import action, { actionFailed } from '../../../util/action'
import consts from '../../../util/consts'
import createAsyncConst from '../../../util/createAsyncConst'

export const FETCH_LAUNDRY_CLIENT = createAsyncConst('FETCH_LAUNDRY_CLIENT')
export const UPDATE_CASHBACK_POINT_VALUE = createAsyncConst('UPDATE_CASHBACK_POINT_VALUE')

export function fetchLaundryClient() {
  return dispatch => {
    dispatch(action(FETCH_LAUNDRY_CLIENT.ACTION))
    return axios
      .get(`${config.API_URL}/laundry-client-edit`)
      .then(resp => {
        dispatch(action(FETCH_LAUNDRY_CLIENT.SUCCESS, resp))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_LAUNDRY_CLIENT, e)))
  }
}

export function updateCashbackPointValue(value = 0, laundryClientId) {
  return dispatch => {
    dispatch(action(UPDATE_CASHBACK_POINT_VALUE.ACTION))
    return axios
      .put(
        `${config.API_URL}/laundry-client/${laundryClientId}/cashback-point-value`,
        { cashback_point_value: value }
      )
      .then(resp => {
        dispatch(action(UPDATE_CASHBACK_POINT_VALUE.SUCCESS, resp))
        return resp
      })
      .catch(e => dispatch(actionFailed(UPDATE_CASHBACK_POINT_VALUE, e)))
  }
}
